<template>
  <svg
    width="1rem"
    height="1rem"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.00003 9.2C2.5582 9.20001 2.20004 9.5582 2.20006 10C2.20007 10.4419 2.55826 10.8 3.00009 10.8L15.0854 10.7996L11.0982 14.8359C10.7877 15.1502 10.7908 15.6568 11.1052 15.9673C11.4195 16.2778 11.926 16.2747 12.2365 15.9603L17.5688 10.5623C17.7284 10.4007 17.8052 10.1882 17.7993 9.97756C17.7934 9.75799 17.699 9.56049 17.5505 9.41941L12.2365 4.03988C11.926 3.72556 11.4195 3.72245 11.1052 4.03295C10.7908 4.34345 10.7877 4.84997 11.0982 5.1643L15.0844 9.19958L3.00003 9.2Z"
      fill="currentColor"
    />
  </svg>
</template>
